export default __webpack_public_path__ + "static/media/tommie_salute_mobile.0e91dc2e.jpg";